<script lang="ts" setup>
import BreadCrumbs from '@components/BreadCrumbs.vue'
import FooterComponent from '@components/FooterComponent.vue'
import HeaderComponent from '@components/HeaderComponent.vue'
import SideBar from '@components/SideBar/SideBar.vue'
</script>

<template>
  <div class="layout">
    <SideBar />

    <div class="page-content">
      <HeaderComponent />

      <main class="page-main">
        <div class="page-main__breadcrumbs">
          <BreadCrumbs />
        </div>

        <VContainer
          class="page-main__body"
          fluid
        >
          <slot />
        </VContainer>
      </main>

      <FooterComponent />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as vars;

.layout {
  display: grid;
  grid-template-columns: var(--ui-sidebar-width) minmax(0, 1fr);
  align-items: start;
  gap: 20px;
  width: 100%;
  min-height: 100vh;
  padding: vars.$app-padding;
  background: var(--ui-canvas);
}

.page-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  min-height: calc(100vh - (vars.$app-padding * 2));
}

.page-main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.page-main__breadcrumbs,
.page-main__body {
  min-width: 0;
  max-width: 100%;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  box-shadow: var(--ui-shadow-sm);
}

.page-main__breadcrumbs:empty {
  display: none;
}

.page-main__body {
  flex: 1 1 auto;
  padding: var(--ui-content-padding);
  overflow-x: auto;
}

// У страниц сущностей есть собственная карточка шапки и карточки контента.
.page-main__body:has(> .entity-page) {
  padding: 0;
  overflow: visible;
  background: transparent;
  border: 0;
  box-shadow: none;
}

@media (max-width: 959px) {
  .layout {
    display: block;
    padding: 0;
  }

  .page-content {
    gap: 0;
    min-height: 100vh;
  }

  .page-main {
    gap: 10px;
    padding: var(--ui-content-padding-mobile);
  }

  .page-main__breadcrumbs,
  .page-main__body {
    border-radius: var(--ui-radius-sm);
  }

  .page-main__body {
    padding: var(--ui-content-padding-mobile);
  }

  .page-main__body:has(> .entity-page) {
    padding: 0;
  }
}
</style>
